
import { defineComponent } from '@vue/composition-api';
import { checkIsGuestAccount } from '@/util/guest-util';

export default defineComponent({
  name: 'LikeAndDislike',
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => {},
    },
    userId: {
      type: String,
      required: true,
      default: '',
    },
    isGuest: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onClickLike', 'onClickDislike'],
  setup(props, { emit }) {
    const onClickLike = (comment: any) => {
      const result = checkIsGuestAccount(true);

      if (result) {
        return;
      }

      const params = {
        id: comment.id,
        userId: props.userId,
        like: 1,
      };

      emit('onClickLike', params);
    };

    const onClickDislike = (comment: any) => {
      const result = checkIsGuestAccount(true);

      if (result) {
        return;
      }

      const params = {
        id: comment.id,
        userId: props.userId,
        like: -1,
      };

      emit('onClickDislike', params);
    };

    return {
      onClickLike,
      onClickDislike,
    };
  },
});
